import React from 'react'
import { Grid, Input, Checkbox, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import CreateandEditIssue from '../../Drive/modals/CreateandEditIssueModal'
import IssueResolvedCard from '../../Drive/cards/IssueResolvedCard'
import CompletedActivityModal from './../../Drive/modals/CompleteActivity';
import OnHoldModal from './../../Drive/modals/OnHoldModal'
import EditPutOnHoldCommentCard from './../../Drive/cards/EditPutOnHoldCommentCard'
import ActivateOnHoldModal from '../../Drive/modals/ActivateOnHoldModal'
import IssueResolvedModal from '../../Drive/modals/IssueResolvedModal'
import IssueLogModal from '../../Drive/modals/ViewIssueLog'
import Labels from './../../../../common/Labels'
import momentDateAndTime from '../../../../../helpers/momentDateAndTime';
import _, { debounce } from "lodash";
var moment = require('moment');

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})


class Status extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            percent: props.selectedActivityData.progress,
            openIssueLog: false,
            openCompletedModal: false,
            onHoldFlag: false,
            clickStatus: '',
            onHoldActivateFlag: false,
            issueModalOpenFlag: false,
            issueClickStatus: '',
            IssueResolvedModalFlag: false,
        }

    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(this.props.selectedActivityData, nextProps.selectedActivityData)) {
            this.setState({ percent: nextProps.selectedActivityData.progress })
        }
    }

    inc = (e, activityData) => {

        if (this.state.percent === 99) {
            this.completedClick(true)
        }
        this.updateProgress()
        this.setState({ percent: this.state.percent + 1 })
    };

    dec = () => {
        if (this.state.percent !== 0) {
            this.updateProgress()
            this.setState({ percent: this.state.percent - 1 })
        }
    };

    updateProgress = debounce(async () => {
        this.props.selectedActivityData.progress = this.state.percent
        if (this.props.activeTab === "myactivities") {
            dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
        }
        else {
            dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
        }

    }, 200);

    startClick = () => {
        this.props.selectedActivityData.runStatus = 1
        this.props.selectedActivityData.actualStartDate = moment()
        this.props.selectedActivityData.string = "startActivity";

        if (this.props.activeTab === "myactivities") {
            dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
        }
        else {
            dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
        }
    }
    reOpenClick = () => {
        this.props.selectedActivityData.runStatus = 0
        this.props.selectedActivityData.progress = 0
        this.props.selectedActivityData.string = "reopenActivity";

        if (this.props.activeTab === "myactivities") {
            dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
        }
        else {
            dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
        }
    }

    issueClick = (issueModalOpenFlag, issueClickStatus) => {
        this.setState({ issueModalOpenFlag: issueModalOpenFlag, issueClickStatus: issueClickStatus })
    }

    completedClick = (openCompletedModal) => {
        this.setState({ openCompletedModal: openCompletedModal })
    }

    markComplete = (e, activityData) => {
        if (e) {
            e.stopPropagation()
        }
        let activityId = activityData._id ? activityData._id : activityData.id
        let sAD = Object.assign({}, activityData)
        sAD._id = activityId
        sAD.oldRunStatus = activityData.runStatus;
        sAD.runStatus = 2
        sAD.onHoldFlag = false;
        sAD.issueFlag = false;
        sAD.progress = 100;
        sAD.completeActivitystring = "MarkAsComplete";
        sAD.string = "";
        sAD.actualEndDate = moment();
        if (this.props.activeTab === "myactivities") {
            dispatch.initiatives.updateMemberActivities(sAD);
        }
        else {
            dispatch.initiatives.updateInitiativeActivities(sAD);
            // :Fetching the initiatives count 
            let payload = {
                organizationId: this.props.selectedOrganisation.id
            }
            dispatch.initiatives.getinitiativesCount(payload);
        }
    }
    OnHoldModalClose = (onHoldFlag) => {
        this.setState({ onHoldFlag: onHoldFlag })
    }
    OnHoldActivateModalClose = (onHoldActivateFlag) => {
        this.setState({ onHoldActivateFlag: onHoldActivateFlag })
    }
    onHoldClick = async (e, data, clickStatus, findUserInR, initiativeCreatedBy) => {
        await dispatch.initiatives.putActivitiesOnHold(this.props.selectedActivityData._id);
        if (this.props.selectedActivityData.runStatus !== -1 && (findUserInR >= 0 || this.props.selectedActivityData.raci.a.accountUserId === this.props.user._id || initiativeCreatedBy === this.props.user._id)) {
            if (data.checked) {
                this.setState({ onHoldFlag: data.checked, clickStatus: clickStatus })
            }
            else {
                if (this.props.selectedActivityData.onHoldComments[0].accountUserId._id === this.props.user._id
                    && this.props.selectedActivityData.onHoldComments[0].isImplicitOnHold) {
                    this.setState({ onHoldActivateFlag: true })
                }
            }
        }
    }
    editOnHold = (data, clickStatus, findUserInR, initiativeCreatedBy) => {
        this.setState({ onHoldFlag: data, clickStatus: clickStatus })
    }

    IssueResolvedModal = (IssueResolvedModalFlag) => {
        this.setState({ IssueResolvedModalFlag: IssueResolvedModalFlag })
    }
    viewIssueLogsClick = (openIssueLog) => {
        this.setState({ openIssueLog: openIssueLog })
    }

    render() {
        // R A and owner of the initative can start/complete/onHold/progress/issue/reopen   activity
        // C I  also put on issue.

        let activityData = this.props.selectedActivityData;
        let selectedInitiaitve = this.props.selectedDataById;
        const findUserInR = activityData && activityData.raci && activityData.raci.r && activityData.raci.r.length && activityData.raci.r.findIndex(x => x.accountUserId === this.props.user._id);

        let todaysDate = new Date().getTime();
        let initiativeStartDate = "";
        let daysDifference = "";
        let initiativeCreatedBy = "";
        if (this.props.activeTab === "myactivities") {
            initiativeStartDate = new Date(activityData.initiativeId.startDate).getTime();
            initiativeCreatedBy = activityData.initiativeId.createdBy
        } else {
            initiativeStartDate = new Date(selectedInitiaitve.startDate).getTime();
            initiativeCreatedBy = selectedInitiaitve.createdBy
        }
        daysDifference = moment.duration(todaysDate - initiativeStartDate).asDays();

        if (daysDifference > 0) {
            daysDifference = Math.abs(daysDifference);
        } else {
            daysDifference = null
        }

        let disabledProgress = (selectedInitiaitve && selectedInitiaitve.status === 3) || activityData.runStatus !== 1 || activityData.onHoldFlag || daysDifference === null ||
            (findUserInR === -1 && activityData.raci.a.accountUserId !== this.props.user._id && initiativeCreatedBy !== this.props.user._id);
        let disabledStartButton = (selectedInitiaitve && selectedInitiaitve.status === 3) || activityData.runStatus !== 0 || activityData.onHoldFlag || daysDifference === null ||
            (findUserInR === -1 && activityData.raci.a.accountUserId !== this.props.user._id && initiativeCreatedBy !== this.props.user._id);

        let disabledCompletedButton = (selectedInitiaitve && selectedInitiaitve.status === 3) || activityData.runStatus === -1 || activityData.runStatus === 2 || activityData.issueFlag || activityData.onHoldFlag || daysDifference === null ||
            (findUserInR === -1 && activityData.raci.a.accountUserId !== this.props.user._id && initiativeCreatedBy !== this.props.user._id);
        let disabledReopenButton = (selectedInitiaitve && selectedInitiaitve.status === 3) || (findUserInR === -1 && activityData.raci.a.accountUserId !== this.props.user._id && initiativeCreatedBy !== this.props.user._id);
        let disabledInProgressButton = true;
        let disabledDelayedButton = true;
        let disabledIssueButton = (selectedInitiaitve && selectedInitiaitve.status === 3) || activityData.issueFlag || activityData.onHoldFlag || activityData.runStatus === 2 || daysDifference === null ||
            (findUserInR === -1 && activityData.raci.a.accountUserId !== this.props.user._id && initiativeCreatedBy !== this.props.user._id);
        let disabledOnHoldButton = activityData.runStatus === -1 || activityData.runStatus === 2 || daysDifference === null ||
            (findUserInR === -1 && activityData.raci.a.accountUserId !== this.props.user._id && initiativeCreatedBy !== this.props.user._id)

        let activeStartButton = activityData.runStatus <= 0 ? disabledStartButton ? "" : "bg-blue bdr-1 bdr-blue" : "";
        let activeInProgressButton = activityData.runStatus === 1 && !activityData.isDelayedToStart && !activityData.isDelayedToEnd && !activityData.issueFlag ? "active_onTrack bdr-1" : ""
        let activeDelayedButton = (activityData.isDelayedToEnd) && activityData.runStatus < 2 ? "active_caution bdr-1" : ""
        let activeIssueButton = activityData.issueFlag ? "active_issue bdr-1" : disabledIssueButton ? "" : "enabled_button"
        let activeCompletedButton = activityData.runStatus === 2 ? "active_completed bdr-1 bdr-blue" : disabledCompletedButton ? "" : "enabled_button"


        return (
            <div>
                <Grid className="activityStatus" >
                    <Grid.Row >
                        <Grid.Column width={8}>
                            <Labels name="Activity Completion"
                                text={<div onMouseEnter={() => dispatch.app.setHelpContext("Status Card - Completion %")}>
                                    <Button disabled={disabledProgress || this.state.percent === 0 || activityData.isSmartActivity} onClick={() => this.dec()} icon="chevron left" className="mar_0 pad_5" ></Button>
                                    <Input disabled type="text" size='mini' icon='percent' placeholder='0' value={this.state.percent} />
                                    <Button disabled={disabledProgress || this.state.percent === 100 || activityData.isSmartActivity} onClick={(e) => this.inc(e, activityData)} icon="chevron right" className="pad_5" ></Button>
                                </div>}
                            />
                        </Grid.Column>

                        <Grid.Column width={8} floated="right" className="text-right">
                            <Labels name="Activity State"
                                text={<div onMouseEnter={() => dispatch.app.setHelpContext("Status Card - Active / On-Hold")}>
                                    <strong>Active</strong>
                                    <Checkbox
                                        // className="onHoldToggleAdjusted"
                                        disabled={disabledOnHoldButton || activityData.isSmartActivity}
                                        checked={activityData.onHoldFlag}
                                        toggle
                                        style={{ margin: "0 10px" }}
                                        onChange={(e, d) => this.onHoldClick(e, d, "addOnHoldComment", findUserInR, initiativeCreatedBy)} />
                                    <strong>On Hold</strong>
                                </div>}
                            />
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column width={16}>
                            {activityData.onHoldFlag && activityData.onHoldComments
                                && activityData.onHoldComments.length ?
                                <EditPutOnHoldCommentCard
                                    selectedActivityData={activityData}
                                    currentNote={this.props.currentNote}
                                    editOnHold={this.editOnHold}
                                    user={this.props.user}

                                /> : ""}
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column width={16}>

                            <div className="statusButtons button_hover">
                                <Button.Group widths='5'>
                                    {activityData.runStatus === 2 ?
                                        <Button
                                            className="bg-blue bdr-1"
                                            disabled={this.props.loadingUpdateInitiativeActivities || disabledReopenButton || activityData.isSmartActivity}
                                            onClick={this.reOpenClick}>Reopen
                                        </Button> :
                                        <Button
                                            className={activeStartButton}
                                            disabled={this.props.loadingUpdateInitiativeActivities || disabledStartButton || activityData.isSmartActivity}
                                            onClick={this.startClick}
                                            onMouseEnter={() => { dispatch.app.setHelpContext("Status Card - Start Button") }}>Start
                                        </Button>
                                    }
                                    <Button
                                        className={activeInProgressButton}
                                        disabled={this.props.loadingUpdateInitiativeActivities || disabledInProgressButton || activityData.isSmartActivity}
                                        onMouseEnter={() => dispatch.app.setHelpContext("Status Card - In-Progress Button")}
                                    >In Progress
                                    </Button>
                                    <Button
                                        className={activeDelayedButton}
                                        disabled={this.props.loadingUpdateInitiativeActivities || disabledDelayedButton || activityData.isSmartActivity}
                                        onMouseEnter={() => dispatch.app.setHelpContext("Status Card - Delayed Button")}
                                    >Delayed
                                    </Button>
                                    <Button
                                        className={activeIssueButton}
                                        disabled={this.props.loadingUpdateInitiativeActivities || disabledIssueButton || activityData.isSmartActivity}
                                        onClick={() => this.issueClick(true, "createIssue")}
                                        onMouseEnter={() => dispatch.app.setHelpContext("Status Card - Issue  Button")}>Issue
                                    </Button>
                                    <Button
                                        style={{ border: 'none' }}
                                        className={activeCompletedButton}
                                        disabled={this.props.loadingUpdateInitiativeActivities || disabledCompletedButton || activityData.isSmartActivity || 
                                            ((activityData.initiativeId && 
                                            activityData.initiativeId.includeChecklist && 
                                            activityData.originalId && 
                                            activityData.originalId.metaDataSchema && 
                                            Object.keys(activityData.originalId.metaDataSchema).length > 0))}
                                        onClick={(e) => this.completedClick(e, activityData)}
                                        onMouseEnter={() => dispatch.app.setHelpContext("Status Card - Completed Button")}>Completed
                                    </Button>
                                </Button.Group>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            {activityData.issueFlag && activityData.issueLogComments
                                && activityData.issueLogComments.length ?
                                <IssueResolvedCard
                                    selectedActivityData={activityData}
                                    currentNote={this.props.currentNote}
                                    issueClick={this.issueClick}
                                    IssueResolvedModal={this.IssueResolvedModal}
                                    user={this.props.user}
                                /> : ""}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            {activityData.runStatus === 0 || activityData.runStatus === -1
                                ?
                                <Labels
                                    name="Expected Start Date"
                                    text={momentDateAndTime(activityData.expectedStartDate)} />
                                :
                                <Labels
                                    name="Started On Date"
                                    text={momentDateAndTime(activityData.actualStartDate)} />
                            }

                            {moment(activityData.expectedStartDate, "MMM DD, YYYY") < moment().format("MMM DD, YYYY")
                                ? "Delayed" : ''}
                        </Grid.Column>
                        <Grid.Column width={8}>
                            {activityData.runStatus === 2 ?
                                <Labels
                                    name="Completion Date"
                                    text={momentDateAndTime(activityData.actualEndDate)} />
                                :
                                <div className="text-right">
                                    <Labels
                                        name="Expected Completion Date"
                                        text={momentDateAndTime(activityData.expectedEndDate)} />
                                </div>

                            }
                        </Grid.Column>

                    </Grid.Row>
                    <Grid.Row className="mar_t_10 pad_0 formcyForm" style={{}}>
                        <Grid.Column width={4}>
                            <span>Smart Activity</span>
                            {/* <i className="info circle icon"></i> */}
                        </Grid.Column>

                        <Grid.Column
                            width={5}
                            style={{}}>
                            <Checkbox
                                toggle
                                // disabled={false ? "disabled" : "enabled"}
                                disabled={true}
                                // defaultChecked
                                checked={activityData ? activityData.isSmartActivity : true}
                                name="inte1"
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <CreateandEditIssue issueModalOpenFlag={this.state.issueModalOpenFlag}
                    issueClick={this.issueClick}
                    selectedActivityData={activityData}
                    issueClickStatus={this.state.issueClickStatus}
                    user={this.props.user}
                    currentNote={this.props.currentNote}
                    activeTab={this.props.activeTab}
                />
                {this.state.openCompletedModal ?
                    <CompletedActivityModal open={this.state.openCompletedModal}
                        completedClick={this.completedClick}
                        selectedActivityData={activityData}
                        organizationId={this.props.selectedOrganisation.id}
                        activeTab={this.props.activeTab}
                        selectedOrganisation={this.props.selectedOrganisation}
                        from="status" /> : null}
                <IssueLogModal openIssueLog={this.state.openIssueLog}
                    viewIssueLogsClick={this.viewIssueLogsClick}
                    selectedActivityData={activityData}
                    activeTab={this.props.activeTab}
                />

                <OnHoldModal onHoldFlag={this.state.onHoldFlag}
                    selectedActivityData={activityData}
                    OnHoldModalClose={this.OnHoldModalClose}
                    currentNote={this.props.currentNote}
                    clickStatus={this.state.clickStatus}
                    user={this.props.user}
                    activityOptions={this.props.activeTab === 'myactivities' ? activityData.initiativeId.activities : selectedInitiaitve.activities}
                    activeTab={this.props.activeTab}
                />
                {activityData.onHoldFlag && activityData.onHoldComments
                    && activityData.onHoldComments.length && activityData.onHoldComments[0].accountUserId._id === this.props.user._id
                    && activityData.onHoldComments[0].isImplicitOnHold ?
                    <ActivateOnHoldModal onHoldActivateFlag={this.state.onHoldActivateFlag}
                        selectedActivityData={activityData}
                        OnHoldActivateModalClose={this.OnHoldActivateModalClose}
                        user={this.props.user}
                        activityOptions={this.props.activeTab === 'myactivities' ? activityData.initiativeId.activities : selectedInitiaitve.activities}
                        activeTab={this.props.activeTab}
                    /> : ''}

                {activityData.issueFlag && activityData.issueLogComments
                    && activityData.issueLogComments.length ?
                    <IssueResolvedModal IssueResolvedModalFlag={this.state.IssueResolvedModalFlag}
                        selectedActivityData={activityData}
                        IssueResolvedModal={this.IssueResolvedModal}
                        user={this.props.user}
                        activeTab={this.props.activeTab}
                    />
                    : ''}
            </div>

        )
    }
}

export default Status;